import { useMutation, useQuery } from "@tanstack/react-query";
import ICalFeedTemplatePaginatedDropdown from "components/dropdowns/paginated/ICalFeedTemplatePaginatedDropdown";
import UserToClientModalPicker from "components/Picker/UserToClientPicker/UserToClientModalPicker";
import React from "react";
import { Button } from "semantic-ui-react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  onCreated: () => void
  excludedUsers?: number[]
  artistId: number
}

const CreateIcalFeed = (props: Props) => {
  const [selected, setSelected] = React.useState<{
    user: server.dto.UserToClientSmall
  }>({
    user: undefined
  });

  const [selectedTemplate, setSelectedTemplate] = React.useState<server.dto.ICalendarTemplateSmall>(undefined);
  const [hasUserError, setHasUserError] = React.useState<boolean>(false);
  const [templateError, setTemplateError] = React.useState<boolean>(false);

  const templatesApi = useQuery({
    queryKey: ["hasIcalTemplates"],
    queryFn: async () => window.CoreApi.ICalendarTemplate.List({ keyword: "", page: 1, perPage: 2 }).then(r => r.data)
  });

  const createFeedApi = useMutation({
    retry: false,
    mutationFn: window.CoreApi.ICalendarFeed.Create
  });

  const onSubmit = async (e) => {
    e?.preventDefault();
    const shouldHaveTemplate = templatesApi.data?.pagination.hasResults ?? false;

    let hasErrors = false;
    if (selected.user == null) {
      setHasUserError(true);
      hasErrors = true;
    }

    if (shouldHaveTemplate && selectedTemplate == null) {
      setTemplateError(true);
      hasErrors = true;
    }

    if (hasErrors) {
      return;
    }

    const result = await createFeedApi.mutateAsync({
      ownerUserToClientId: selected.user.userToClientId,
      iCalendarTemplateId: selectedTemplate?.iCalendarTemplateId,
      artistId: props.artistId
    });

    if (!result.data.hasErrors) {
      props.onCreated();
    }
  };

  return <>

    <div>
      <div>
        {RESX.GeneralLabels.AssignTo}
      </div>
      <UserToClientModalPicker
        value={selected.user}
        required
        validatorKey="userToClient"
        canCreateNew={false}
        legacyHasError={hasUserError}
        canChooseExternal
        onChange={(user) => {
          setSelected({ user });
          setHasUserError(false);
        }}

      />
    </div>
    {templatesApi.data?.pagination.hasResults && <div className="margin-top">
      <div>
        {RESX.Template.ICalendarTemplate}
      </div>
      <div className="flex">
        <div className="grow1">
          <ICalFeedTemplatePaginatedDropdown
            value={selectedTemplate}
            onChange={t => {
              setSelectedTemplate(t);
              setTemplateError(false);
            }}
            config={{
              isSearchable: true,
              shouldRenderSelectedValue: true,
              hasError: templateError
            }}
          />
        </div>
        <div className="margin-left-small" style={{ alignSelf: "center" }}>
          <a className="icon-cog" href={routes.iCalendarTemplate_List().absolute} />
        </div>
      </div>
    </div>}
    {createFeedApi.data?.data.errors.length > 0 &&
      <div className="red margin-top">
        {createFeedApi.data.data.errors[0].message}
      </div>}
    <div className="flex margin-top-huge">
      <div className="grow1">

      </div>
      <div>
        <Button disabled={createFeedApi.isLoading} loading={createFeedApi.isLoading} primary type="submit" onClick={onSubmit}>{RESX.Buttons.btnSave}</Button>
      </div>
    </div>
  </>;
};

export default CreateIcalFeed;